var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"el-fade-in","mode":"out-in"}},[(_vm.getValidationItem != null)?_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.getValidationItem.Value))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }